import { __awaiter } from "tslib";
import { EventType } from './defs';
import createLogger from './logger';
import { logger } from './util';
export default class Reporter {
    constructor(options, middlewares) {
        // 上报队列
        this.queue = [];
        // 是否延迟上报
        this.delay = false;
        this.middlewares = middlewares;
        this.delay = (options === null || options === void 0 ? void 0 : options.delay) || false;
        this.logger = createLogger((options === null || options === void 0 ? void 0 : options.silent) || false);
        this.init(options);
        if (!this.delay) {
            this.ready();
        }
    }
    init(options) {
        this.runMiddleware((reporter) => { var _a; return (_a = reporter.init) === null || _a === void 0 ? void 0 : _a.call(reporter, options); });
    }
    /**
     * 设置额外上报参数
     */
    setExtraParams(params) {
        this.runMiddleware((reporter) => reporter.setExtraParams(params));
    }
    /**
     * 上报就绪
     */
    ready() {
        return __awaiter(this, void 0, void 0, function* () {
            this.delay = false;
            yield Promise.all(this.runMiddleware((reporter) => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield reporter.ready();
                }
                catch (e) {
                    logger.warn('[Reporter.ready]中间件ready异常', e);
                }
            })));
            let queueItem;
            while (queueItem = this.queue.shift()) {
                const [params, event] = queueItem;
                this.report(params, event);
            }
        });
    }
    /**
     * 上报
     * @param params 上报参数
     * @param event 事件类型
     */
    report(params, event = EventType.EXPOSE) {
        if (this.delay) {
            this.queue.push([params, event]);
            return;
        }
        this.logger(event, params);
        this.runMiddleware((reporter) => reporter.report(params, event));
    }
    /**
     * 曝光上报
     * @param params 上报参数
     */
    expose(params) {
        this.report(params, EventType.EXPOSE);
    }
    /**
     * 点击上报
     * @param {ReportParams} params 上报参数
     */
    click(params) {
        this.report(params, EventType.CLICK);
    }
    /**
     * 执行中间件方法
     * @param fn {function}
     * @return any[]
     */
    runMiddleware(fn) {
        if (Array.isArray(this.middlewares)) {
            return this.middlewares.map((reporter) => fn(reporter));
        }
        return [];
    }
}
/**
 * 创建上报器
 * @param {ReporterOptions} options 上报配置
 * @param {IMiddleware[]} middlewares 上报中间件
 *
 * @return {Reporter}
 */
export function createReporter(options, middlewares) {
    return new Reporter(options, middlewares);
}
